import React from 'react';
import { Button as ButtonV2, Color } from '@bb/elements-web-rebranding';
import { Flex, Title, Text, Button } from '@brokerbay/elements-web';
import styled from 'styled-components';
import { featureEnabled } from 'utils';

export type NoMoreShowingsOverlayProps = {
  allowOverride?: boolean;
  listingId: string;
  listingStatus: string;
  onOverride: (...args: any[]) => void;
};

const NoMoreShowingsOverlay: React.FC<NoMoreShowingsOverlayProps> = ({
  allowOverride,
  listingId,
  listingStatus,
  onOverride,
}) => {
  const hasSupraRebrandingFeature = featureEnabled('supraRebrandingFeature', 1);
  return (
    <StyledMainFlex vertical>
      <Title level={4} dataCy="noMoreShowingsOverlay-title">
        No More Showings
      </Title>
      <Text>Property Status: {listingStatus}</Text>
      {allowOverride && (
        <StyledButtonFlex gap="small">
          {hasSupraRebrandingFeature ? (
            <ButtonV2
              href={`/#/listing/${listingId}/view`}
              type="secondary"
              dataCy="cancelNoMoreShowings-btn"
              color="primary"
              styleOverride={{
                borderColor: Color.BEERUS,
                /* TODO: [KUSA-870] The `ant-btn` class is overriding the top padding using `!important`,
                so this line manually restores it. Revisit this when removing the rebranding Button import. */
                paddingTop: '7px !important',
              }}
            >
              Cancel
            </ButtonV2>
          ) : (
            <Button
              href={`/#/listing/${listingId}/view`}
              type="secondary"
              dataCy="cancelNoMoreShowings-btn"
            >
              Cancel
            </Button>
          )}
          {hasSupraRebrandingFeature ? (
            <ButtonV2 dataCy="overrideNoMoreShowings-btn" onClick={onOverride}>
              Override, Book Showing
            </ButtonV2>
          ) : (
            <Button dataCy="overrideNoMoreShowings-btn" onClick={onOverride}>
              Override, Book Showing
            </Button>
          )}
        </StyledButtonFlex>
      )}
    </StyledMainFlex>
  );
};

const StyledMainFlex = styled(Flex)`
  padding: 10px 25px;
`;
const StyledButtonFlex = styled(Flex)`
  margin-top: 12px;
`;

export default NoMoreShowingsOverlay;
